class ManualLightbox extends Modal {
  constructor() {
    super();
  }

  openModalEvent(trigger) {
    super.openModalEvent(trigger);

    const container = trigger.closest("[data-manual-image-container]");
    const image = container.querySelector("[data-media]");
    const placeholder = this.content.querySelector("[data-modal-placeholder]");

    if (image) this.cloneImage(image, placeholder);
  }

  cloneImage(image, placeholder) {
    const clonedImage = image.cloneNode(true);

    if (placeholder) placeholder.innerHTML = clonedImage.outerHTML;
  }
}

if (!customElements.get('manual-lightbox')) {
  customElements.define('manual-lightbox', ManualLightbox);
}